import {SelectedView} from "../types/types";

export const ENV = process.env.REACT_APP_BUILD_ENV ?? "dev";
export const SERVER_URL: string = `${process.env.REACT_APP_SERVER_URL}${ENV}`;

export const DIAGNOSIS_PATH: string = "/diagnosis"
export const PROCEDURES_PATH: string = "/procedures"
export const QUESTIONNAIRES_PATH: string = "/questionnaires"
export const FILL_CLIENT_FORM_PATH: string = "/fill-client-form"

export const GET_VERSIONS_PATH: string = "/versions"
export const GET_TREE_PATH: string = "/tree"
export const GET_QUESTIONNAIRES_COUNTS = "/questionnaires-counts"
export const SUBMIT_CLIENT_FORM_PATH: string = "/submit_client_form"

export const PATH: Record<SelectedView, string> = {
    [SelectedView.Diagnosis]: GET_TREE_PATH,
    [SelectedView.Procedures]: GET_TREE_PATH,
    [SelectedView.Questionnaires]: GET_QUESTIONNAIRES_COUNTS
};


export const SIDE_BAR_TREE_PLACEHOLDER = "Select or search a category"

export const DASHBOARD_INSIGHT_TITLE = "📊 Data Insights Dashboard"
export const DASHBOARD_SELECT_TEXT = "Select a category from the sidebar to explore demographic breakdowns."
export const DASHBOARD_SELECT_NODE_TEXT = "️ Please select a node from the tree on the sidebar."

export const DASHBOARD_SELECTED_PREFIX = "📌 Selected: "
export const DASHBOARD_SELECTED_NODE_TYPE_PREFIX = "🗂️ Node Type: "
export const DASHBOARD_SELECTED_PARTICIPANT_COUNT_PREFIX = "👥 Total Participant Count: "

export const AGE_GRAPH_X_AXIS_TITLE = "Age Group"
export const AGE_GRAPH_Y_AXIS_TITLE = "Participant Count"

export const VALUES_FOR_SEARCH = "values_for_search"

export const CURRENT_VERSION_TEXT = "Current version:"
export const VERSIONS_DATE_TEXT = "From date"

export const GENERAL_ERROR_TEXT = "An error occurred. Please try again later."